import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const EMPTY_VALUE = "-";

/**
 * Datos de solo lectura en cuadrícula compacta: etiqueta pequeña y valor como
 * texto, sin cajas de formulario. Estilos en scss/dhn/_detail-list.scss.
 *
 * <DetailList items={[{ label: "Cédula", value: "001..." }, { label: "Dirección", value, wide: true }]} />
 */
export function DetailItem({ label, value, wide }) {
  const isEmpty = value === null || value === undefined || value === "";

  return (
    <div className={classnames("dhn-detail-list__item", { "dhn-detail-list__item--wide": wide })}>
      <dt>{label}</dt>
      <dd>{isEmpty ? EMPTY_VALUE : value}</dd>
    </div>
  );
}

DetailItem.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  wide: PropTypes.bool,
};

export default function DetailList({ items = [], className, children }) {
  return (
    <dl className={classnames("dhn-detail-list", className)}>
      {items.map((item) => (
        <DetailItem key={item.label} {...item} />
      ))}
      {children}
    </dl>
  );
}

DetailList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(DetailItem.propTypes)),
  className: PropTypes.string,
  children: PropTypes.node,
};

/** Lista corta de valores (especialidades, etiquetas) como chips. */
export function DetailChips({ items = [], emptyText }) {
  if (!items.length) {
    return <p className="dhn-detail-chips__empty">{emptyText}</p>;
  }

  return (
    <ul className="dhn-detail-chips">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

DetailChips.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
  emptyText: PropTypes.node,
};
